/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 26.07.17.
 */
import _ from "underscore";

/**
 * Parameter parser. Replaces placeholders with provided params or data values.
 * Placeholders should be specified as follows:
 *  "{{" - replaced by the string "{"
 *  "{:prop}" - replaced by the value of the property "prop" of params object
 *  "{.param}" - replaced by the value of the property "param" of data object
 *  "{paramOrProp}" - replaced by the value of the property "paramOrProp" of data object and if not found then with the value of the propery "paramOrProp" of params object
 */
class ParamParser {
    constructor(params, data) {
        this.params = params;
        this.data = data;
    }

    formatUrl(url) {
        return url.replace(/{{|{[^{}]+}/g, function (value) {
            return encodeURIComponent(this.getParamValue(value));
        }.bind(this));
    }

    formatValue(value) {
        return value.replace(/{{|{[^{}]+}/g, function (value) {
            return this.getParamValue(value);
        }.bind(this));
    }

    replaceValues(data) {
        return _.mapObject(data, function (val, key) {
            return this.getParamValue(val);
        }.bind(this));
    }

    getParamValue(param) {
        if (param == null) return param;
        if (_.isArray(param)) {
            return _.map(param, function (v) {
                return this.getParamValue(v);
            }.bind(this));
        }
        if (_.isObject(param)) {
            return _.mapObject(param, function (v, k) {
                return this.getParamValue(v);
            }.bind(this));
        }
        if (!_.isString(param)) return param;
        if (param === "{{") return "{";
        if (param.startsWith("{:")) {
            let propName = param.substring(2, param.length-1);
            if (this.params && this.params[propName]) return this.params[propName];
            return "";
        }
        if (param.startsWith("{.")) {
            let propName = param.substring(2, param.length-1);
            if (this.data && this.data[propName]) return this.data[propName];
            return "";
        }
        if (param.charAt(0) === "{" ) {
            let varName = param.substring(1, param.length-1);
            if (this.data && this.data[varName]) return this.data[varName];
            if (this.params && this.params[varName]) return this.params[varName];
            return "";
        }
        return param;
    }
}

export default ParamParser;
